import { Grid } from '@mantine/core';
import type { AiTokenUsageMetrics } from '@repo/api-codegen';
import { memo, useCallback } from 'react';
import type { AiTokenUsageMetricCardType } from '../../types';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsAiTokenUsageCardsProps {
	aiTokenUsageMetrics: AiTokenUsageMetrics;
	onMetricCardClick?: (metricType: AiTokenUsageMetricCardType) => void;
}

export const MetricsAiTokenUsageCards = memo(
	({
		aiTokenUsageMetrics,
		onMetricCardClick,
	}: MetricsAiTokenUsageCardsProps) => (
		<Grid py="lg" w="100%" gutter="md">
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Total requests"
					value={aiTokenUsageMetrics?.total_requests ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Total Requests'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Input tokens"
					value={aiTokenUsageMetrics?.total_input_tokens ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Input Tokens'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Output tokens"
					value={aiTokenUsageMetrics?.total_output_tokens ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Output Tokens'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Cache write tokens"
					value={aiTokenUsageMetrics?.total_cache_creation_input_tokens ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Cache Creation Input Tokens'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Cache read tokens"
					value={aiTokenUsageMetrics?.total_cache_read_input_tokens ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Cache Read Input Tokens'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Total tokens"
					value={aiTokenUsageMetrics?.total_tokens ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Total Tokens'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
		</Grid>
	)
);
